import { Button } from '@mui/material';
import React, { useRef, useState } from 'react';

function Section() {
  return (
    <section className='section'>
      <h5 className='skip'>Section Title</h5>
      <div className='section-inner'>
        <article>
          <h3>
            <span>Brand Story</span>
            <strong>브랜드 스토리</strong>
          </h3>
          <p className='brand-title'> 
            <strong>“뮤트소요, 고요함 속의 산책”</strong>
            <span>Photo Studio & Cafe</span>
          </p>
          <p className='description'>
            <strong>뮤트소요(Mute Soyo)</strong>는 사진 스튜디오와 카페가 함께 있는 공간입니다.
            일상의 소란함을 잠시 멈추고, 나만의 생각과 추억 속을 천천히 거니는 소요(逍遙)의 시간을 제안합니다.
          </p>
        </article>
        <article>
          <h3>
            <span>The Space</span>
            <strong>공간 안내</strong>
          </h3>
          <dl>
            <dt>1F Cafe</dt>
            <dd>Brewed Coffee: 엄선된 원두로 내린 커피</dd>
            <dd>수요일 – 일요일 운영</dd>
            <dt>2F Photo Studio</dt>
            <dd>셀프 촬영(개인 프로필 및 반려동물 동반 촬영)</dd>
            <dd>전문 촬영 장비 셋팅</dd>
            <dd>100% 사전 예약제</dd>
          </dl>
        </article>
        <article>
          <h3>
            <span>Studio Services</span>
            <strong>촬영 서비스</strong>
          </h3>
          <div className='card-wrap'>
            <div className='card'>
              <h4 className='card-title'>Natural Portrait</h4>
              <div className='card-contents'>                
                <p className='desc'>
                  <em>당신의 가장 자연스러운 순간</em>
                  <span>인물의 본연의 매력을 담아내는 실내 포트레이트 전문 촬영입니다.</span>
                </p>
              </div>
            </div>
            <div className='card'>
              <h4 className='card-title'>Specialty: Pet Portraits</h4>
              <div className='card-contents'>
                <p className='desc'>
                  <em>반려동물과 함께하는 기록</em>
                  <span>
                    뮤트소요가 가장 애정을 가지고 진행하는 작업 중 하나인 반려동물 촬영입니다. 
                    스튜디오 촬영은 물론 야외 산책 스냅까지 지원합니다. 
                  </span>
                  <span>"가족의 일원인 반려동물의 소중한 순간을 차분한 시선으로 담아냅니다."</span>
                </p>
              </div>
            </div>            
            <div className='card'>
              <h4 className='card-title'>Outdoor & Candid Snap</h4>
              <div className='card-contents'>                
                <p className='desc'>
                  <em>자연스러운 시선의 기록</em>
                  <span>주요 관광지와 주변의 풍경을 배경으로 자연스러운 순간을 기록합니다.</span>
                </p>
                <ul>
                  <li>인위적이지 않은 '캔디드 샷(Candid Shot)' 컨셉</li>
                  <li>외국인 관광객을 위한 여행 기록 스냅</li>
                  <li>도심 속 자연스러운 거리 풍경 연출</li>
                </ul>
              </div>
            </div>
          </div>
        </article>
        <article>
          <h3>
            <span>Shared Space</span>
            <strong>렌탈 안내</strong>
          </h3>
          <dl>
            <dt>
              <span>Monday & Tuesday 공간의 확장</span>
              매주 월요일과 화요일은 창작과 몰입을 위한 공유 공간으로 운영됩니다. 
              무인 시스템으로 방해받지 않고 자유롭게 이용하실 수 있습니다.
            </dt>
            <dd>Work & Study: 팀 프로젝트, 개인 업무, 스터디를 위한 대여</dd>
            <dd>Creative Rental: 촬영, 팝업, 행사 등을 위한 공간 전체 대관</dd>
          </dl>
        </article>
        <article>
          <h3>
            <span>Operation Hours</span>
            <strong>운영 시간</strong>
          </h3>
          <dl>
            <dt>수~일</dt>
            <dd>Photo Studio & Cafe</dd>
            <dd>09:00 ~ 20:00</dd>
            <dt>월, 화</dt>
            <dd>공간 대관 운영(사전 예약제)</dd>
          </dl>
        </article>
      </div>
    </section>
  );
}

export default Section;